
// import 'leaflet-routing-machine'; // Install leaflet-routing-machine
// import { CloseOutlined } from '@ant-design/icons';
// import { Button, Modal ,message } from 'antd';
// import React, { useState } from 'react';
// import { useNavigate } from "react-router-dom"; 
// import CompensatoryIcon from '../../images/CompensatoryTrees.svg';
// import InSituIcon from '../../images/InSituTrees.svg';
// import CalendarIcon from '../../images/calendar.svg';
// import TransplantIcon from '../../images/TransplantTrees.svg';
// import GirthIcon from '../../images/Girth.svg';
// import LatitudeIcon from '../../images/Latitude.svg';
// import LongitudeIcon from '../../images/Longitude.svg';
// import EditIcon from '../../images/EditForm.svg';
// import QRCODEIcon from '../../images/QRCodeIcon.svg';
// import DirectionsIcon from '../../images/DirectionIcon.svg'; 
// import "./TreeInfoModal.css";
// import L from "leaflet";
// import "leaflet/dist/leaflet.css";


// const TreeInfoModal = ({ tree, visible, onClose, mapInstance, currentLocation  }) => {
//   const [zoomStyle, setZoomStyle] = useState({});
//   const [zoomVisible, setZoomVisible] = useState(false); // To toggle zoom visibility
//   const [imageModalVisible, setImageModalVisible] = useState(false); // For the new image modal
//   const [qrModalVisible, setQrModalVisible] = useState(false);
//   const navigate = useNavigate();



//   const handleEditClick = () => {
  
//     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
  
//     if (!token) {
//       message.warning('Please log in to edit tree details.');
//       return;
//     }
  
//     navigate(`/edit-tree/${tree.properties.tid}`, { state: { tree } });
//   };

//   if (!tree) return null;
  

  
//   const treeImages = tree?.properties?.tree_images || []; // Ensure it's an array

  
//   const latestImage = treeImages.length > 0
//   ? treeImages.reduce((latest, current) =>
//       current.id > latest.id ? current : latest
//     ).image
//   : tree.properties?.image || "image is not available";
//   const imageUrl = latestImage.includes('?') 
//   ? `${latestImage}&t=${new Date().getTime()}` 
//   : `${latestImage}?t=${new Date().getTime()}`;

//   const handleMouseMove = (e) => {
//     const { width, height, left, top } = e.target.getBoundingClientRect();
//     const mouseX = e.clientX - left;
//     const mouseY = e.clientY - top;

//     // Define the zoom window size
//     const zoomWindowSize = 150; // Size of the zoom window (150x150px)

//     // Calculate the zoom position based on the mouse position
//     const zoomX = (mouseX / width) * 100;
//     const zoomY = (mouseY / height) * 100;

//     // Update the zoom window style and visibility
//     setZoomStyle({
//       backgroundPosition: `${zoomX}% ${zoomY}%`,
//       backgroundSize: `${width * 2}% ${height * 2}%`, // Zoom in 2x
//     });

//     setZoomVisible(true); // Show the zoom panel
//   };

//   const handleMouseLeave = () => {
//     setZoomVisible(false); // Hide the zoom panel when the mouse leaves the image
//   };

//   const handleImageClick = () => {
//     setImageModalVisible(true); // Show the image modal
//   };

//   const handleImageModalClose = () => {
//     setImageModalVisible(false); // Hide the image modal
//   };
//   const handleQrClick = () => {
//     setQrModalVisible(true); // Show the QR code modal
//   };

//   const handleQrModalClose = () => {
//     setQrModalVisible(false); // Hide the QR code modal
//   };

//   const handleDirectionsClick = () => {
//     if (!currentLocation || !tree.geometry?.coordinates) {
//       alert('Current location or tree location not available.');
//       return;
//     }

//     const [treeLon, treeLat] = tree.geometry.coordinates;
//     const { lat: currentLat, lng: currentLng } = currentLocation;

//     const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${currentLat},${currentLng}&destination=${treeLat},${treeLon}`;
//     window.open(googleMapsUrl, '_blank'); // Open Google Maps in a new tab
//   };

//   return (
//     <Modal
//       visible={visible}
//       onCancel={onClose}
//       footer={null}
//       width={741}
//       closable={false}
//       style={{
//          // Remove padding from the Modal itself
//         borderRadius: '9.7px',
//         position: 'relative',
//         padding:"0px",
//       }}
//     >
       

//        {(sessionStorage.getItem('token') || localStorage.getItem('token')) && (
//           <div style={{ position: 'absolute', top: '20px', right: '20px', zIndex: 20 }}>
//           <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
//             <img
//               src={EditIcon}
//               alt="Edit Icon"
//               style={{
//                 width: '20px',
//                 height: '20px',
//                 cursor: 'pointer',
//                 borderRadius: '4px',
//                 pointerEvents: 'auto',
//               }}
//               onClick={handleEditClick}
//             />
//             <button
//               onClick={handleEditClick}
//               style={{
//                 marginLeft: '0px',
//                 fontSize: '14px',
//                 marginTop: '5px',
//                 fontWeight: 'bold',
//                 color: '#00917D',
//                 background: 'none',
//                 border: 'none',
//                 cursor: 'pointer',
//                 pointerEvents: 'auto',
//               }}
//             >
//               <span style={{ color: '#00917D', fontWeight: 'bold', paddingRight: '0px' }}>Edit</span>
//             </button>
//           </div>
//         </div>
//         )}



//           <div style={{ position: 'absolute', top: '-10px', right: '-5px', zIndex: 10 }}>
//             <Button
//               icon={<CloseOutlined style={{ color: 'white', fontSize: '14px', fontWeight: 'bold' }} />}
//               onClick={onClose}
//               type="text"
//               style={{
//                 backgroundColor: 'red',
//                 cursor: 'pointer',
//                 width: '24px', // Smaller width
//                 height: '24px', // Smaller height
//                 borderRadius: '50%', // Circular shape
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//               }}
//             />
//           </div>


//       <div
//         style={{
//           height: '278px', // Set the fixed height here
//           width:"700px",
//           padding: '0px', // Adjust padding if needed
//           overflow: 'hidden', // Prevent overflow if the content is larger
//           borderRadius: '12px',
//           display: 'flex', // Use flexbox for horizontal alignment
//           flexDirection: 'row', // Align items horizontally (left image and right info)
//           gap: '20px', // Gap between image and content
//         }}
//       >
//         {/* Left Side: Image */}
//         <div
//           style={{
//             position: 'relative',
//             width: '268px',
//             height: '280px',
//             borderRadius: '9.47px',
//             cursor: 'zoom-in',
//             overflow: 'hidden',
           
            
//           }}
//           onMouseMove={handleMouseMove}
//           onMouseLeave={handleMouseLeave}
//           onClick={handleImageClick} // Handle image click to open the new panel
//         >
//           <img
//             src={latestImage}
//             alt="Tree"
//             style={{
//               width: '100%',
//               height: '100%',
//               borderRadius: '12px',
//               transition: 'transform 0.2s ease-in-out',
    
//               backgroundSize: '200%', // Set the zoom scale for the background image
//               backgroundPosition: zoomStyle.backgroundPosition,
//             }}
//           />
//         </div>

//         {/* Right Side: Basic Tree Information */}
//         <div
//           style={{
//             flex: 1,
//             display: 'flex',
//             flexDirection: 'column',
//             gap: '5px',
//             fontFamily: "'Poppins-thin', sans-serif",
//             paddingTop: '05px',
//             marginTop: '05px',
//             position: 'relative',
//           }}
//         >
//           <div>
//             {/* Tree Details */}
//             <p style={{ margin: 0, fontSize: '14px', paddingLeft: '0px', paddingBottom: '05px', }}>
//               <span style={{ color: '#414141', fontWeight:"bold",paddingRight:"5px",  }}>ID:</span> {tree.properties.tree_number || 'N/A'}
//             </p>
//             <p
//               style={{
//                 margin: '0px 0',
//                 paddingLeft: '0px',
//                 fontSize: '14px',
                
//                 color: '#00917D',
//                 paddingBottom: '05px',
//               }}
//             >
//               <span style={{ color: '#414141',  fontWeight:"bold", paddingRight:"5px",}}>Tree Name:</span> < span  style={{ fontWeight: 'semiBold', }}> {tree.properties.tree_name || 'N/A'}</span> 
//             </p>
//             <p
//               style={{
//                 margin: '0px 0',
//                 paddingLeft: '0px',
//                 fontSize: '14px',
//                 fontWeight: 'bold',
//                 color: '#00917D',
//                 paddingBottom: '5px',
//                 display: 'flex', // Ensures everything is in one row
//                 alignItems: 'center', // Align the items vertically centered
//               }}
//             >
//               <span style={{ color: '#414141', paddingRight:"5px",}}>Type:</span>
//               <span
//                 style={{
//                   color: tree.properties.survey_type === 'in_situ'
//                     ? '#A3DD7F' // Green for In Situ
//                     : tree.properties.survey_type === 'transplant'
//                     ? '#FFA1E3' // Pink for Transplant
//                     : tree.properties.survey_type === 'compensatory'
//                     ? '#FA9658' // Orange for Compensatory
//                     : 'black', // Default black if no match
//                   display: 'flex',
//                   alignItems: 'center', // Align the icon and text horizontally
//                   marginLeft: '5px', // Add space between the label and the value
//                 }}
//               >
//                 {tree.properties.survey_type === 'in_situ' && (
//                   <img
//                     src={InSituIcon}
//                     alt="In Situ Icon"
//                     style={{ width: '20px', height: '20px', marginRight: '5px' }} // Add margin between icon and text
//                   />
//                 )}
//                 {tree.properties.survey_type === 'transplant' && (
//                   <img
//                     src={TransplantIcon}
//                     alt="Transplant Icon"
//                     style={{ width: '20px', height: '20px', marginRight: '5px' }}
//                   />
//                 )}
//                 {tree.properties.survey_type === 'compensatory' && (
//                   <img
//                     src={CompensatoryIcon}
//                     alt="Compensatory Icon"
//                     style={{ width: '20px', height: '20px', marginRight: '5px' }}
//                   />
//                 )}
//                 {tree.properties.survey_type || 'N/A'}
//               </span>
//             </p>


           
//             <p
//               style={{
//                 margin: '0px 0',
//                 paddingLeft: '0px',
//                 fontSize: '14px',
//                 color: '#000000',
//                 paddingBottom: '05px',
                
//               }}
//             >
//               <span style={{ color: '#414141', fontWeight:"bold",paddingRight:"5px", }}>Scientific Name:</span> <span style={{ color: '#414141', fontWeight:"bold",paddingRight:"5px",fontStyle: 'italic', }}>{tree.properties.tree_scientific_name || 'N/A'}</span> 
//             </p>
//             <p
//               style={{
//                 margin: '0px 0',
//                 paddingLeft: '0px',
//                 fontSize: '14px',
//                 color: '#000000',
//                 paddingBottom: '5px',
                
//               }}
//             >
//               <span style={{ color: '#414141',   fontWeight:"bold",paddingRight:"5px",}}>Location:</span> {tree.properties.station_name || 'N/A'}
//             </p>
//           </div>

//           {/* Additional Information */}
//           <div
//             style={{
//               display: 'grid',
//               gridTemplateColumns: 'repeat(4, 1fr)',
//               gap: '5px',
//               fontFamily: "'Poppins-thin', sans-serif",
//               marginTop: '10px',
//             }}
//           >
//             {/* Date */}
//             <div style={{ display: 'flex', flexDirection: 'column', gap: '0px' }}>
//               <div style={{ display: 'flex', alignItems: 'center', gap: '0px' }}>
//                 <img
//                   src={CalendarIcon}
//                   alt="Calendar Icon"
//                   style={{ width: '16px', height: '16px', fontSize: '14px', paddingTop: '10px', paddingBottom: '0px', paddingRight: '5px' }}
//                 />
//                 <p style={{ margin: 0, fontSize: '14px', color: '#6A6A6A', paddingTop: '10px', paddingBottom: '0px' }}>Date</p>
//               </div>

//               <p style={{ marginTop: '0px', fontWeight: 'bold', paddingLeft: '20px', fontSize: '14px', paddingTop: '0px', paddingBottom: '0px', marginBottom: '0px' }}>
//                 {tree.properties.survey_date || 'N/A'}
//               </p>
//             </div>

//             {/* Girth */}
//             <div style={{ display: 'flex', flexDirection: 'column', gap: '0px' }}>
//               <div style={{ display: 'flex', alignItems: 'center', gap: '0px' }}>
//                 <img
//                   src={GirthIcon}
//                   alt="Girth Icon"
//                   style={{ width: '16px', height: '16px', paddingTop: '10px', paddingBottom: '0px', paddingRight: '5px' }}
//                 />
//                 <p style={{ margin: 0, fontSize: '14px', color: '#6A6A6A', paddingTop: '10px', paddingBottom: '0px' }}>Girth</p>
//               </div>

//               <p style={{ margin: 0, fontWeight: 'bold', fontSize: '14px', paddingBottom: '0px', paddingLeft: '20px' }}>
//                 {tree.properties.girth || 'N/A'} cm
//               </p>
//             </div>

//             {/* Latitude */}
//             <div style={{ display: 'flex', flexDirection: 'column', gap: '0px' }}>
//               <div style={{ display: 'flex', alignItems: 'center', gap: '0px' }}>
//                 <img
//                   src={LatitudeIcon}
//                   alt="Latitude Icon"
//                   style={{ width: '16px', height: '16px', paddingTop: '10px', paddingBottom: '0px', paddingRight: '5px' }}
//                 />
//                 <p style={{ margin: 0, fontSize: '14px', color: '#6A6A6A', paddingTop: '10px', paddingBottom: '0px' }}>Latitude</p>
//               </div>

//               <p style={{ margin: 0, fontWeight: 'bold', fontSize: '14px', paddingBottom: '0px', paddingLeft: '20px' }}>
//                 {tree?.geometry?.coordinates?.[1] ? tree.geometry.coordinates[1].toFixed(4) : 'N/A'}
//               </p>
//             </div>

//             {/* Longitude */}
//             <div style={{ display: 'flex', flexDirection: 'column', gap: '0px' }}>
//               <div style={{ display: 'flex', alignItems: 'center', gap: '0px' }}>
//                 <img
//                   src={LongitudeIcon}
//                   alt="Longitude Icon"
//                   style={{ width: '16px', height: '16px', paddingTop: '10px', paddingBottom: '0px', paddingRight: '5px' }}
//                 />
//                 <p style={{ margin: 0, fontSize: '14px', color: '#6A6A6A', paddingTop: '10px', paddingBottom: '0px' }}>Longitude</p>
//               </div>

//               <p style={{ margin: 0, fontWeight: 'bold', fontSize: '14px', paddingBottom: '0px', paddingLeft: '20px' }}>
//                 {tree?.geometry?.coordinates?.[0] ? tree.geometry.coordinates[0].toFixed(4) : 'N/A'}
//               </p>
//             </div>
//           </div>
//           <span
//             style={{
//               marginTop: '25px',
//               paddingLeft: '0px',
//               fontSize: '13px',
//               color: '#00917D',
//               paddingBottom: '0px',
//               display: 'flex',
//               alignItems: 'center',
//               gap: '35px',
//             }}
//           >
//             {/* Directions Icon with Text */}
//             <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
//               <img
//                 src={DirectionsIcon}
//                 alt="Directions Icon"
//                 style={{
//                   width: '20px',
//                   height: '20px',
//                   cursor: 'pointer',
//                   borderRadius: '4px',
//                 }}
//                 onClick={handleDirectionsClick}
//               />
//               <button
//                 onClick={handleDirectionsClick}
//                 style={{
//                   marginLeft: '0px',
//                   fontSize: '13px',
//                   fontWeight: 'bold',
//                   color: '#00917D',
//                   background: 'none',
//                   border: 'none',
//                   textDecoration: 'underline', // Underline the text
//                   cursor: 'pointer',
//                 }}
//               >
//                 GET DIRECTIONS
//               </button>
//             </div>

//             {/* QR Code Icon with Text */}
//             {tree.properties.qr_code && (
//               <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
//                 <img
//                   src={QRCODEIcon}
//                   alt="QR Code"
//                   style={{
//                     width: '20px',
//                     height: '20px',
//                     cursor: 'pointer',
//                     borderRadius: '0px',
//                   }}
//                   onClick={handleQrClick} // Open the modal on click
//                 />
//                 <button
//                   onClick={handleQrClick}
//                   style={{
//                     marginLeft: '0px',
//                     fontSize: '13px',
//                     fontWeight: 'bold',
//                     color: '#00917D',
//                     background: 'none',
//                     border: 'none',
//                     textDecoration: 'underline', // Underline the text
//                     cursor: 'pointer',
//                   }}
//                 >
//                   SCAN TO VIEW INFORMATION
//                 </button>
//               </div>
//             )}
//           </span>


//         </div>
//       </div>
//         {/* Zoom Panel */}
//         {zoomVisible && (
//         <div
//           style={{
//             position: 'absolute',
//             top: '0%', // Set to middle of the modal for better alignment
//             left: 'calc(100% - 410px)', // Position to the right of the image container
//             width: '350px', // Increased width of the zoom panel
//             height: '450px', // Increased height of the zoom panel
//             border: '5px solid #ffffff',
//             background: 'white', // Transparent background for the zoom panel
//             zIndex: 10, // Ensure it sits on top
//             boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//           }}
//         >
//           <div
//             style={{
//               width: '100%',
//               height: '100%',
//               backgroundImage: `url(${latestImage})`, // Set the image as background
//               backgroundSize: zoomStyle.backgroundSize,
//               backgroundPosition: zoomStyle.backgroundPosition,
//               borderRadius: '0px', // Rounded corners for the zoom panel
//             }}
//           />
//         </div>
//       )}
//          {/* Image Modal */}
//          <Modal
//             visible={imageModalVisible}
//             onCancel={handleImageModalClose}
//             footer={null}
//             width={700}
//             height={300}
//             closable={false}
//             style={{
//               padding: '0px',
//               position: 'relative',
//               top: '10%',  // Adjust the top position to make it closer to the center
//             }}
//           >
//               <Button
//                 icon={<CloseOutlined />}
//                 onClick={handleImageModalClose}
//                 type="text"
//                 style={{
//                   backgroundColor: 'red',
//                   color: 'white',
//                   border: 'none',
//                   fontSize: '16px',
//                   cursor: 'pointer',
//                   position: 'absolute',
//                   top: '10px',
//                   right: '10px',
//                 }}
//               />
//               <img
//                 src={latestImage}
//                 alt="Tree"
//                 style={{
//                   width: '100%',
//                   height: 'auto',
//                   borderRadius: '12px',
//                 }}
//               />
//           </Modal>
//        {/* QR Code Modal */}
//        <Modal
//         visible={qrModalVisible}
//         onCancel={handleQrModalClose}
//         footer={null}
//         width={400}
//         height={400}
//         closable={false}
//         style={{
//           padding: '20px',
//           position: 'relative',
//         }}
//       >
//         <Button
//           icon={<CloseOutlined />}
//           onClick={handleQrModalClose}
//           type="text"
//           style={{
//             backgroundColor: 'red',
//             color: 'white',
//             border: 'none',
//             fontSize: '16px',
//             cursor: 'pointer',
//             position: 'absolute',
//             top: '10px',
//             right: '10px',
//           }}
//         />
//         <img
//           src={tree.properties.qr_code || 'image not available'}
//           alt="QR Code"
//           style={{
//             width: '100%',
//             height: 'auto',
//             borderRadius: '12px',
//           }}
//         />
//       </Modal>
//     </Modal>

//   );
// };

// export default TreeInfoModal;


import 'leaflet-routing-machine';
import { CloseOutlined } from '@ant-design/icons';
import { Button, Modal, message } from 'antd';
import React, { useState } from 'react';
import { useNavigate } from "react-router-dom"; 
import CompensatoryIcon from '../../images/CompensatoryTrees.svg';
import InSituIcon from '../../images/InSituTrees.svg';
import CalendarIcon from '../../images/calendar.svg';
import TransplantIcon from '../../images/TransplantTrees.svg';
import GirthIcon from '../../images/Girth.svg';
import LatitudeIcon from '../../images/Latitude.svg';
import LongitudeIcon from '../../images/Longitude.svg';
import EditIcon from '../../images/EditForm.svg';
import QRCODEIcon from '../../images/QRCodeIcon.svg';
import DirectionsIcon from '../../images/DirectionIcon.svg'; 
import "./TreeInfoModal.css";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const TreeInfoModal = ({ tree, visible, onClose, mapInstance, currentLocation }) => {
  const [zoomStyle, setZoomStyle] = useState({});
  const [zoomVisible, setZoomVisible] = useState(false);
  const [imageModalVisible, setImageModalVisible] = useState(false);
  const [qrModalVisible, setQrModalVisible] = useState(false);
  const navigate = useNavigate();

  const handleEditClick = () => {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    if (!token) {
      message.warning('Please log in to edit tree details.');
      return;
    }
    navigate(`/edit-tree/${tree.properties.tid}`, { state: { tree } });
  };

  if (!tree) return null;

  const treeImages = tree?.properties?.tree_images || [];
  const latestImage = treeImages.length > 0
    ? treeImages.reduce((latest, current) => current.id > latest.id ? current : latest).image
    : tree.properties?.image || "image is not available";
  const imageUrl = latestImage.includes('?') 
    ? `${latestImage}&t=${new Date().getTime()}` 
    : `${latestImage}?t=${new Date().getTime()}`;

  const handleMouseMove = (e) => {
    const { width, height, left, top } = e.target.getBoundingClientRect();
    const mouseX = e.clientX - left;
    const mouseY = e.clientY - top;
    const zoomX = (mouseX / width) * 100;
    const zoomY = (mouseY / height) * 100;
    setZoomStyle({
      backgroundPosition: `${zoomX}% ${zoomY}%`,
      backgroundSize: `${width * 2}% ${height * 2}%`,
    });
    setZoomVisible(true);
  };

  const handleMouseLeave = () => setZoomVisible(false);
  const handleImageClick = () => setImageModalVisible(true);
  const handleImageModalClose = () => setImageModalVisible(false);
  const handleQrClick = () => setQrModalVisible(true);
  const handleQrModalClose = () => setQrModalVisible(false);

  const handleDirectionsClick = () => {
    if (!currentLocation || !tree.geometry?.coordinates) {
      alert('Current location or tree location not available.');
      return;
    }
    const [treeLon, treeLat] = tree.geometry.coordinates;
    const { lat: currentLat, lng: currentLng } = currentLocation;
    const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${currentLat},${currentLng}&destination=${treeLat},${treeLon}`;
    window.open(googleMapsUrl, '_blank');
  };

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={765}
      closable={false}
      className="tree-info-modal"
    >
      {(sessionStorage.getItem('token') || localStorage.getItem('token')) && (
        <div className="edit-container">
          <img src={EditIcon} alt="Edit Icon" className="edit-icon" onClick={handleEditClick} />
          <button className="edit-button" onClick={handleEditClick}>Edit</button>
        </div>
      )}

      <div className="close-button-container">
        <Button
          icon={<CloseOutlined />}
          onClick={onClose}
          type="text"
          className="close-button"
        />
      </div>

      <div className="tree-modal-container">
        <div
          className="tree-image-container"
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
          onClick={handleImageClick}
        >
          <img src={latestImage} alt="Tree" className="tree-image" />
        </div>

        <div className="tree-info-container">
          <p className="tree-id">ID: {tree.properties.tree_number || 'N/A'}</p>
          <p className="tree-name">Tree Name: <span>{tree.properties.tree_name || 'N/A'}</span></p>
          <p className="tree-type">
            Type: 
            <span className={tree.properties.survey_type}>
              {tree.properties.survey_type === 'in_situ' && <img src={InSituIcon} alt="In Situ Icon" />}
              {tree.properties.survey_type === 'transplant' && <img src={TransplantIcon} alt="Transplant Icon" />}
              {tree.properties.survey_type === 'compensatory' && <img src={CompensatoryIcon} alt="Compensatory Icon" />}
              {tree.properties.survey_type || 'N/A'}
            </span>
          </p>
          <p className="tree-scientific-name">Scientific Name: <span>{tree.properties.tree_scientific_name || 'N/A'}</span></p>
          <p className="tree-location">Location: {tree.properties.station_name || 'N/A'}</p>

          <div className="tree-additional-info">
            <div className="tree-info-item">
              <div><img src={CalendarIcon} alt="Calendar Icon" /> Date</div>
              <span>{tree.properties.survey_date || 'N/A'}</span>
            </div>
            <div className="tree-info-item">
              <div><img src={GirthIcon} alt="Girth Icon" /> Girth</div>
              <span>{tree.properties.girth || 'N/A'} cm</span>
            </div>
            <div className="tree-info-item">
              <div><img src={LatitudeIcon} alt="Latitude Icon" /> Latitude</div>
              <span>{tree?.geometry?.coordinates?.[1]?.toFixed(4) || 'N/A'}</span>
            </div>
            <div className="tree-info-item">
              <div><img src={LongitudeIcon} alt="Longitude Icon" /> Longitude</div>
              <span>{tree?.geometry?.coordinates?.[0]?.toFixed(4) || 'N/A'}</span>
            </div>
          </div>

          <div className="action-buttons">
            <div className="action-item">
              <img src={DirectionsIcon} alt="Directions Icon" onClick={handleDirectionsClick} />
              <button onClick={handleDirectionsClick}>GET DIRECTIONS</button>
            </div>
            {tree.properties.qr_code && (
              <div className="action-item">
                <img src={QRCODEIcon} alt="QR Code" onClick={handleQrClick} />
                <button onClick={handleQrClick}>SCAN TO VIEW INFORMATION</button>
              </div>
            )}
          </div>
        </div>
      </div>

      {zoomVisible && (
        <div className="zoom-panel" style={zoomStyle}>
          <div style={{ backgroundImage: `url(${latestImage})` }} />
        </div>
      )}

      <Modal
        visible={imageModalVisible}
        onCancel={handleImageModalClose}
        footer={null}
        className="image-modal"
      >
        {/* <Button icon={<CloseOutlined />} onClick={handleImageModalClose} className="close-button" /> */}
        <img src={latestImage} alt="Tree" />
      </Modal>

      <Modal
        visible={qrModalVisible}
        onCancel={handleQrModalClose}
        footer={null}
        className="qr-modal"
      >
        {/* <Button icon={<CloseOutlined />} onClick={handleQrModalClose} className="close-button" /> */}
        <img src={tree.properties.qr_code || 'image not available'} alt="QR Code" />
      </Modal>
    </Modal>
  );
};

export default TreeInfoModal;